import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import accountingService from "./accountingService";
import { flashMessage as flash } from "./../../../utils/flash/index";

const initialState = {
  accounts: null,
  all_accounts: null,
  gl_groups: [],
  isLoading: false,
  isSuccess: false,
  isError: false,
  isUpdated: false,
  isReversed: false,
  journals: null,
  gl_accounts: null,
  related_transactions: null,
  message: "",
};

export const accountingSlice = createSlice({
  name: "accounting",
  initialState,
  reducers: {
    resetChartOfAccountState: (state) => (state = initialState),
    resetChartOfAccountStatus: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.isUpdated = false;
      state.isReversed = false;
    },
    resetRelatedTransactions: (state) => {
      state.related_transactions = null;
    },

    resetJournals: (state) => {
      state.journals = null;
    },
  },
  extraReducers: (builder) => {
    builder
      //create chart of accounting
      .addCase(createChartAccount.pending, (state) => {
        state.pending = true;
        flash("loading", "Creating chart of Account");
      })
      .addCase(createChartAccount.fulfilled, (state, action) => {
        state.pending = false;
        state.isSuccess = true;
        if (action.payload.data) {
          state.isUpdated = true;
          flash("success", action.payload.message);
        } else {
          let key = Object.keys(action.payload.errors)[0];
          let message = action.payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(createChartAccount.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload.message);
      })
      // get gl groups for gl_accounts
      .addCase(getGlGroups.pending, (state) => {
        state.pending = true;
      })
      .addCase(getGlGroups.fulfilled, (state, action) => {
        state.pending = false;
        state.isSuccess = true;
        state.gl_groups = action.payload.data;
      })
      .addCase(getGlGroups.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload.message);
      })
      // get paginated accounts
      .addCase(getAccounts.pending, (state) => {
        state.pending = true;
      })
      .addCase(getAccounts.fulfilled, (state, action) => {
        state.pending = false;
        state.isSuccess = true;
        state.accounts = action.payload.data;
      })
      .addCase(getAccounts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload.message);
      })
      // get accounts
      .addCase(getAllAccounts.pending, (state) => {
        state.pending = true;
      })
      .addCase(getAllAccounts.fulfilled, (state, action) => {
        state.pending = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.all_accounts = action.payload;
      })
      .addCase(getAllAccounts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload.message);
      })
      // get gl accounts
      .addCase(getGlAccounts.pending, (state) => {
        state.pending = true;
      })
      .addCase(getGlAccounts.fulfilled, (state, action) => {
        state.pending = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.gl_accounts = action.payload;
      })
      .addCase(getGlAccounts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload.message);
      })
      // edit an account
      .addCase(editChartAccount.pending, (state) => {
        state.pending = true;
        flash("loading", "Updating..!");
      })
      .addCase(editChartAccount.fulfilled, (state, action) => {
        state.pending = false;
        state.isSuccess = true;
        if (action.payload.data) {
          state.isUpdated = true;
          flash("success", action.payload.message);
        } else {
          let key = Object.keys(action.payload.errors)[0];
          let message = action.payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(editChartAccount.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload.message);
      })
      // create journals
      .addCase(createJournal.pending, (state) => {
        state.pending = true;
        flash("loading", "Creating..!");
      })
      .addCase(createJournal.fulfilled, (state, action) => {
        state.pending = false;
        state.isLoading = false;
        state.isSuccess = true;
        if (action.payload.message) {
          state.isUpdated = true;
          state.journals = action.payload;
          flash("success", action.payload.message);
        } else {
          let key = Object.keys(action.payload.errors)[0];
          if (key === "0") {
            flash("error", action.payload.errors);
          } else {
            flash("error", action.payload.errors[key][0]);
          }
        }
      })

      .addCase(createJournal.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload.message);
      })

      // filter journals
      .addCase(filterJournals.pending, (state) => {
        state.pending = true;
        flash("loading", "Searching..!");
      })
      .addCase(filterJournals.fulfilled, (state, action) => {
        state.pending = false;
        state.isLoading = false;
        state.isSuccess = true;
        if (action.payload.message) {
          state.isUpdated = true;
          state.journals = action.payload;
          flash("success", action.payload.message);
        } else {
          flash("error", action.payload.errors);
        }
      })

      .addCase(filterJournals.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload.message);
      })

      // reverse transaction

      .addCase(reverseTransaction.pending, (state) => {
        state.pending = true;

        flash("loading", "Reversing transaction..!");
      })
      .addCase(reverseTransaction.fulfilled, (state, action) => {
        state.pending = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.isReversed = true;
        if (action.payload.message) {
          state.isUpdated = true;
          state.journals = action.payload;
          flash("success", action.payload.message);
        } else {
          flash("error", action.payload.errors);
        }
      })
      .addCase(reverseTransaction.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload.message);
      })

      // get filtered journals
      .addCase(getFiltered.fulfilled, (state, action) => {
        if (action.payload) {
          state.isUpdated = true;
          state.journals = action.payload;
        }
      })
      //   delete chart of account
      .addCase(deleteChartOfAccount.pending, (state) => {
        state.isLoading = true;
        flash("loading", "Deleting account...");
      })
      .addCase(deleteChartOfAccount.fulfilled, (state, action) => {
        if (action.payload) {
          state.isUpdated = true;
          if (action.payload.errors) {
            flash("error", action.payload.errors);
            return;
          }
          flash("success", action.payload.message);
        }
      })
      .addCase(getRelatedTransactions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getRelatedTransactions.fulfilled, (state, action) => {
        if (action.payload) {
          state.isUpdated = true;
          state.related_transactions = action.payload;
        }
      })
      .addCase(getRelatedTransactions.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload.message);
      });
  },
});

export const getGlGroups = createAsyncThunk(
  "getGlGroups",
  async (ID, thunkAPI) => {
    try {
      return await accountingService.getGlGroups(ID);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAccounts = createAsyncThunk(
  "getAccounts",
  async (pageNumber, thunkAPI) => {
    try {
      return await accountingService.getAccounts(pageNumber);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getAllAccounts = createAsyncThunk(
  "getAllAccounts",
  async (_, thunkAPI) => {
    try {
      return await accountingService.getAllAccounts();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getGlAccounts = createAsyncThunk(
  "getGlAccounts",
  async (_, thunkAPI) => {
    try {
      return await accountingService.getGlAccounts();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// create chart of accounts
export const createChartAccount = createAsyncThunk(
  "createChartAccount",
  async (DATA, thunkAPI) => {
    try {
      return await accountingService.createChartAccount(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const editChartAccount = createAsyncThunk(
  "editChartAccount",
  async (DATA, thunkAPI) => {
    try {
      return await accountingService.editChartAccount(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// create journals
export const createJournal = createAsyncThunk(
  "createJournal",
  async (DATA, thunkAPI) => {
    try {
      return await accountingService.createJournal(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// filter journals
export const filterJournals = createAsyncThunk(
  "filterJournals",
  async (DATA, thunkAPI) => {
    try {
      return await accountingService.filterJournals(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// get filtered paginated journals
export const getFiltered = createAsyncThunk(
  "getFiltered",
  async (pageNumber, thunkAPI) => {
    try {
      return await accountingService.getFiltered(pageNumber);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getRelatedTransactions = createAsyncThunk(
  "getRelatedTransactions",
  async (transaction_id, thunkAPI) => {
    try {
      return await accountingService.getRelatedTransactions(transaction_id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const reverseTransaction = createAsyncThunk(
  "reverseTransaction",
  async (DATA, thunkAPI) => {
    try {
      return await accountingService.reverseTransaction(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteChartOfAccount = createAsyncThunk(
  "deleteChartOfAccount",
  async (DATA, thunkAPI) => {
    try {
      return await accountingService.deleteChartOfAccount(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const {
  resetChartOfAccountState,
  resetChartOfAccountStatus,
  resetJournals,
  resetRelatedTransactions,
} = accountingSlice.actions;
export default accountingSlice.reducer;
